<template>
  <div class="banner_template">
    <ion-row class="preview-banner">
      <ion-col class="preview-title">
        PREVIEW MODE
      </ion-col>
      <ion-col class="limited-feature-text">
        Limited features. <span class="learn_more_text" @click="openPopOver($event)">Learn more</span>
      </ion-col>
      <ion-col>
        <ion-button class="back-button" @click="closePreviewMode()">Close preview</ion-button>
      </ion-col>
    </ion-row>

  </div>
</template>

<script>
import {IonButton, IonCol, IonIcon, IonRow, popoverController} from '@ionic/vue';
import {defineComponent, reactive} from 'vue';
import PreviewLimitedFeaturePopover from "./PreviewLimitedFeaturePopover";
import global_methods from "@/utils/globalFunctions";


export default defineComponent({
  name: 'PreviewModeBanner',
  components: {
    IonIcon,
    IonCol,
    IonRow,
    IonButton,

  },
  props: {},


  setup(props, ctx) {
    const state = reactive({});

    const closePreviewMode = global_methods.closePreview;


    async function openPopOver(event) {

      let css_class = 'preview-mode-popup';
      const popover = await popoverController.create({
        component: PreviewLimitedFeaturePopover,
        cssClass: css_class,
        event: event,
        arrow: true,
        mode: "md",
        translucent: true,
        showBackdrop: false,
        alignment: "alignment"
      });

      let popover_content_div = popover.shadowRoot.querySelector('.popover-wrapper');
      popover_content_div.style.opacity = '0%';
      await popover.present();
      popover_content_div.style.top = (event.y - 150) + 'px';
      popover_content_div.style.opacity = '100%';
      popover_content_div.style.transition = 'opacity linear 0.3s'

      const {role} = await popover.onDidDismiss();

    }

    return {state, closePreviewMode, openPopOver};
  },


});
</script>

<style lang="scss" scoped>

.banner_template {
  position: fixed;
  bottom: 20px;
  left: 0px;
  width: 96%;
  margin-left: 2%;
  margin-right: 2%;
}

.preview-banner {

  max-width: 520px;
  margin-left: auto;
  margin-right: auto;

  position: relative;
  border-radius: 5px;
  min-height: 40px;

  background-color: #2D2F3F;
  display: flex;
  align-items: center;
  font-family: Helvetica;
  font-size: 10px;
  box-shadow: 0px 8px 17px rgba(0, 0, 0, 0.28);

  .preview-title {
    font-style: normal;
    font-weight: bold;
    line-height: 22px;
    align-items: center;
    letter-spacing: 0.08em;
    padding-left: 26px;
    padding-right: 19px;
    border-right: 1px solid #52556D;
    color: #FF6146;
    max-width: 135px;
  }

  .limited-feature-text {
    padding-left: 18px;
    font-size: 11px;
    font-weight: normal;
    color: variables.$color-white;

    a {
      color: variables.$color-white !important;
    }
  }

  .back-button {
    --color: #FFFFFF;
    --background: #52556D;
    font-size: 11px;
    line-height: 22px;
    margin-right: 8px;
    width: 107px;
    height: 26px;
    position: relative;
    float: right;
    display: block;
    font-weight: 400;
  }

  .learn_more_text {
    text-decoration: underline;
    cursor: pointer;
  }
}


</style>
